import { useContext, useEffect, useState } from "react";
import AntdTable from "../../../antd/Table/Table";
import { filtrationcontext } from "../../../../context/Filtercontext";
import trans, { getLateLimitInMinutes, isRTL } from "../../../../utils";
import { exportContext } from "../../../../context/ExportDataContext";
import { Tag } from "antd";

const DailyAttendanceReportTable = ({
  startDate,
  endDate,
  currentPage,
  setCurrentPage,
  data,
  isLoading,
  selectedids,
  filters,
}) => {
  const { setFileName, setExportIds, setStartDateE, setEndDateE, setFilters } =
    useContext(exportContext);
  const {
    setSort: SetSortFilter,
    limit,
    setLimit,
  } = useContext(filtrationcontext);
  const [sort, setSort] = useState({
    by: "",
    order: "",
  });

  useEffect(() => {
    return () => {
      SetSortFilter({ type: "", value: "" });
      localStorage.setItem("page", 1);
    };
  }, [SetSortFilter]);

  const columns = [
    {
      title: trans("Code"),
      dataIndex: "employeeId",
      width: 150,
      fixed: !isRTL ? "left" : undefined,
      render: (name) => (
        <span className={"table-element-name ps-0"}>{name}</span>
      ),
    },
    {
      title: trans("Name"),
      dataIndex: "technicianName",
      width: 150,
      sorter: true,
      fixed: !isRTL ? "left" : undefined,
    },
    {
      title: trans("Job Title"),
      dataIndex: "jobTitle",
      width: 150,
      sorter: true,
    },
    {
      title: trans("Date"),
      dataIndex: "date",
      width: 150,
      fixed: !isRTL ? "left" : undefined,
    },
    // {
    //   title: trans("department"),
    //   dataIndex: "department",
    //   width: 150,
    //   sorter: true,
    // },
    {
      title: trans("Supervisor"),
      dataIndex: "supervisor",
      width: 150,
    },
    {
      title: trans("Assigned Shift"),
      dataIndex: "assignedShift",
      width: 250,
      render: (_, record) => record?.assignedShift || "0",
    },
    {
      title: trans("Actual Shift"),
      dataIndex: "shiftStartTime",
      width: 250,
      render: (_, record) =>
        `${record?.shiftStartTime} - ${record?.shiftEndTime}` || "0",
    },
    {
      title: trans("Work Hours"),
      dataIndex: "workMinutes",
      width: 150,
      render: (_, record) => record?.workHours || "0",
    },
    {
      title: trans("Early Leave"),
      dataIndex: "earlyLeaveMinutes",
      width: 150,
      render: (_, record) => {
        const limit = getLateLimitInMinutes(
          filters.lateThreshold,
          filters.lateUnit
        );
        const totalLate = record?.earlyLeaveMinutes || 0;
        const formatted = record?.earlyLeaveHours || "0";
        const isExceeded = limit !== null && totalLate > limit;

        return <span>{formatted}</span>;
      },
    },
    {
      title: trans("Late Hours"),
      dataIndex: "lateMinutes",
      width: 150,
      render: (_, record) => {
        const limit = getLateLimitInMinutes(
          filters.lateThreshold,
          filters.lateUnit
        );
        const totalLate = record?.lateMinutes || 0;
        const formatted = record?.lateHours || "0";
        const isExceeded = totalLate > limit;
        return (
          <span style={{ color: isExceeded ? "red" : "green" }}>
            {formatted}
          </span>
        );
      },
    },
    {
      title: trans("Overtime"),
      dataIndex: "overtimeMinutes",
      width: 150,
      render: (_, record) => (
        <Tag color={record?.overtimeMinutes >= 1 ? "green" : "default"}>
          {record?.overtimeHours || "0"}
        </Tag>
      ),
    },
  ];

  useEffect(() => {
    if (data) {
      setStartDateE(startDate);
      setEndDateE(endDate);
    }
  }, [data, startDate, endDate, selectedids]);

  const handleTableChange = (pagination, filters, sorter) => {
    if (sorter.order) {
      SetSortFilter({
        by: sorter.field,
        order: sorter.order === "ascend" ? "asc" : "desc",
      });
    } else {
      SetSortFilter({
        by: "",
        order: "",
      });
    }
  };

  return (
    <div className="bg-white-rounded-top mt-3 table-parent">
      <AntdTable
        columns={columns}
        dataSource={data?.technicians || []}
        loading={isLoading}
        pageSize={limit}
        totalItems={data?.totalResults || 0}
        currentPage={currentPage}
        onPageChange={(page) => setCurrentPage(page)}
        onLimitChange={(newLimit) => {
          setLimit(newLimit);
          setCurrentPage(1);
        }}
        onTableChange={handleTableChange}
        scrollY={350}
      />
    </div>
  );
};

export default DailyAttendanceReportTable;
